exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-editor-textarea {\n  min-width: 100%;\n  max-width: 100%;\n}\n.template-editor-value-formatted {\n  margin: 0;\n}\n.filter-template-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n", ""]);

